import React, { useMemo, useState, useEffect, useCallback } from "react";
import Customtable from "../helper/Customtable";
import Swal from "sweetalert2";
import { post } from "../helper/api_helper";
import CommonModal from "../components/CommonModal";

const EMPTY_BALANCE = {
  totalPackages: null,
  totalWeight: null,
  usedPackages: 0,
  usedWeight: 0,
  balancePackages: null,
  balanceWeight: null,
};

const toNum = (val) => {
  const n = parseFloat(val);
  return Number.isFinite(n) ? n : 0;
};

const Despatch = () => {
  const [jobOptions, setJobOptions] = useState([]);
  const [containerOptions, setContainerOptions] = useState([]);
  const [shedOptions, setShedOptions] = useState([]);
  const [containerBalances, setContainerBalances] = useState(EMPTY_BALANCE);

  const [despatchList, setDespatchList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [referencePage, setReferencePage] = useState(0);
  const [blPage, setBlPage] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const showAlert = useCallback((icon, title, text, timer = 2000) => {
    Swal.fire({
      icon,
      title,
      text: text || "Something went wrong.",
      timer,
      showConfirmButton: false,
    });
  }, []);

  const [formData, setFormData] = useState({ despatch_id: 0 });

  const filteredContainerOptions = useMemo(() => {
    if (!formData.job_id_fk) {
      return [{ value: "", label: "Select BL No. first" }];
    }
    const base = containerOptions.filter((c) => c.value !== "");

    const selectedJobId = String(formData.job_id_fk);
    const list = base.filter((c) => String(c.job_id_fk) === selectedJobId);
    return [{ value: "", label: "Select Container" }, ...list];
  }, [containerOptions, formData.job_id_fk]);

  const formFields = useMemo(() => [
    { type: "section", label: "Job & Container" },
    {
      name: "job_id_fk", label: "BL No.", type: "select", required: true, col: 6,
      options: jobOptions
    },
    {
      name: "container_id_fk", label: "Container", type: "select", required: true, col: 6,
      options: filteredContainerOptions
    },
    { name: "despatch_date", label: "Despatch Date", type: "date", col: 6 },
    { type: "section", label: "Vehicle Details" },
    { name: "lorry_number", label: "Lorry Number", type: "text", col: 6 },
    { name: "vehicle_type", label: "Vehicle Type", type: "text", col: 6 },
    { name: "rc_book_load_ability", label: "RC Book load Ability", type: "number", col: 6 },
    { name: "minimum_guarnty", label: "Minimum Guarnty", type: "number", col: 6 },
    { name: "driver_name", label: "Driver Name", type: "text", col: 6 },
    { name: "driver_phone", label: "Driver Phone", type: "text", col: 6 },
    { name: "driver_license", label: "Driver License", type: "text", col: 6 },
    { name: "rc_book", label: "RC Book", type: "text", col: 6 },
    { name: "rc_book_expiry_date", label: "RC Book Expiry Date", type: "date", col: 6 },
    { name: "insurance_expiry_date", label: "Insurance Expiry Date", type: "date", col: 6 },
    {
      name: "shed_name", label: "Shed Name", type: "select", col: 6,
      options: shedOptions
    },
    { name: "shed_contact_no", label: "Shed Contact No", type: "text", col: 6, readOnly: true },
    { type: "section", label: "Cargo & Finance" },
    {
      name: "no_of_packages",
      label: `No. of Packages${containerBalances.balancePackages != null ? ` (Balance: ${containerBalances.balancePackages})` : ""}`,
      type: "number",
      col: 6,
      max: containerBalances.balancePackages != null ? containerBalances.balancePackages : undefined,
    },
    {
      name: "package_unit", label: "Package Unit", type: "select", col: 6,
      options: [
        { value: "", label: "-Select-" },
        { value: "BDL", label: "BUNDLE (BDL)" },
        { value: "CAS", label: "CASES (CAS)" },
        { value: "SHT", label: "SHEETS (SHT)" },
        { value: "CHT", label: "CHEST (CHT)" },
        { value: "CLS", label: "COILS (CLS)" },
        { value: "COL", label: "COLLIES (COL)" },
        { value: "CON", label: "CONTAINER (CON)" },
        { value: "CRT", label: "CRATES (CRT)" },
        { value: "CSK", label: "WOODEN CASKS (CSK)" },
        { value: "CTN", label: "CARTONS (CTN)" },
        { value: "CYL", label: "CYLINDER (CYL)" },
        { value: "DRM", label: "DRUMS (DRM)" },
        { value: "ENV", label: "STEEL ENVELOPES (ENV)" },
        { value: "FLK", label: "FLASK (FLK)" },
        { value: "FUT", label: "FUTS (FUT)" },
        { value: "HBK", label: "HABBUCK (HBK)" },
        { value: "JBL", label: "JUMBLE BALE (JBL)" },
        { value: "JTA", label: "JOTTA (JTA)" },
        { value: "KEG", label: "KEGGS (KEG)" },
        { value: "LFT", label: "LIFT (LFT)" },
        { value: "LOG", label: "LOGS (LOG)" },
        { value: "NGT", label: "INGOT (NGT)" },
        { value: "PAL", label: "PALLS (PAL)" },
        { value: "PKG", label: "PACKAGES (PKG)" },
        { value: "PLT", label: "PALLETS (PLT)" },
        { value: "QDS", label: "QUADS (QDS)" },
        { value: "REL", label: "REELS (REL)" },
        { value: "RLS", label: "ROOLS (RLS)" },
        { value: "SKD", label: "SKID & SKIDDED PKGS (SKD)" },
        { value: "SLB", label: "SLABS (SLB)" },
        { value: "TBL", label: "TABLE (TBL)" },
        { value: "TIN", label: "TINS (TIN)" },
        { value: "TRK", label: "TRUNK (TRK)" },
        { value: "UNT", label: "UNITS (UNT)" },
        { value: "PCS", label: "PIECES (PCS)" },
        { value: "BAL", label: "BALES" },
      ]
    },
    {
      name: "weight",
      label: `Weight (MT)${containerBalances.balanceWeight != null ? ` (Balance: ${containerBalances.balanceWeight})` : ""}`,
      type: "number",
      col: 6,
      max: containerBalances.balanceWeight != null ? containerBalances.balanceWeight : undefined,
    },
    { name: "freight_amount", label: "Freight Amount (₹)", type: "number", col: 6 },
    { name: "avg_freight", label: "Average Freight", type: "number", col: 6, readOnly: true },
    { name: "cost_per_ton", label: "Market Rate/Ton (₹)", type: "number", col: 6 },
    { type: "section", label: "Documents" },
    { name: "e_way_bill_no", label: "e-Way Bill No.", type: "text", col: 6 },
    { name: "e_way_bill_date", label: "e-Way Bill Date", type: "date", col: 6 },
    { name: "e_way_bill_expiry", label: "e-Way Bill Expiry", type: "date", col: 6 },
    { name: "gc_no", label: "GC No.", type: "text", col: 6 },
    { name: "gc_date", label: "GC Date", type: "date", col: 6 },
    { name: "reached_date", label: "Reached Date", type: "date", col: 6 },
    {
      name: "remarks",
      label: "Remarks",
      type: "textarea",
      col: 12,
    },
  ], [jobOptions, filteredContainerOptions, shedOptions, containerBalances]);

  // ------------------------------
  // Initial Form State
  // ------------------------------
  const initialFormState = useMemo(() => {
    return formFields.reduce((acc, field) => {
      if (field.name) acc[field.name] = "";
      return acc;
    }, { despatch_id: 0 });
  }, [formFields]);

  // Keep formData in sync with the initial shape once fields are known
  useEffect(() => {
    setFormData((prev) => ({ ...initialFormState, ...prev }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialFormState]);

  // ------------------------------
  // Fetch Data
  // ------------------------------
  const fetchData = useCallback(async () => {
    try {
      const response = await post("/operations/despatch/list");
      if (response.status === 200) {
        setDespatchList(response.data);
      } else {
        showAlert("error", response.status, response.message);
      }
    } catch (err) {
      showAlert("error", "Unexpected Error", err.message);
    }
  }, [showAlert]);

  const fetchJobData = useCallback(async () => {
    try {
      const response = await post("/all_jobs/job/list");
      if (response.status === 200) {
        setJobOptions([
          { value: "", label: "Select Job" },
          ...response.data.map(item => ({
            value: item.job_id,
            label: item.bl_number,
          }))
        ]);
      }
    } catch (err) {
      console.log(err.message);
    }
  }, []);

  const fetchContainerData = useCallback(async () => {
    try {
      const response = await post("/all_jobs/containers/list");
      if (response.status === 200) {
        setContainerOptions([
          { value: "", label: "Select Container" },
          ...response.data.map(item => ({
            value: item.container_id,
            label: item.container_no,
            job_id_fk: item.job_id_fk,
            // Container master field names vary a bit across endpoints —
            // fall back across the likely aliases instead of assuming one.
            total_packages: item.no_of_packages ?? item.total_packages ?? item.packages ?? 0,
            total_weight: item.weight ?? item.total_weight ?? item.gross_weight ?? 0,
          }))
        ]);
      }
    } catch (err) {
      console.log(err.message);
    }
  }, []);

  const fetchShedData = useCallback(async () => {
    try {
      const response = await post("/masters/transporter/list");
      if (response.status === 200) {
        setShedOptions([
          { value: "", label: "Select Shed" },
          ...response.data.map(item => ({
            value: item.transporter_id,
            label: item.shed_name,
            contact_no: item.contact_no
          }))
        ]);
      }
    } catch (err) {
      console.log(err.message);
    }
  }, []);

  useEffect(() => {
    fetchData();
    fetchJobData();
    fetchContainerData();
    fetchShedData();
  }, [fetchData, fetchJobData, fetchContainerData, fetchShedData]);

  useEffect(() => {
    const freight = parseFloat(formData.freight_amount);
    const weight = parseFloat(formData.weight);

    if (freight && weight && weight !== 0) {
      const avg = (freight / weight).toFixed(2);
      setFormData(prev => ({
        ...prev,
        avg_freight: avg
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        avg_freight: ""
      }));
    }
  }, [formData.freight_amount, formData.weight]);

  // ------------------------------
  // Balance Calculator (per container — used to cap the despatch form)
  // ------------------------------
  const computeBalance = useCallback((containerId, excludeDespatchId = null) => {
    if (!containerId) {
      setContainerBalances(EMPTY_BALANCE);
      return;
    }
    // Coerce to string before comparing — select values are always strings,
    // but IDs coming from the API may be numeric.
    const containerIdStr = String(containerId);
    const container = containerOptions.find(c => String(c.value) === containerIdStr);
    if (!container) {
      setContainerBalances(EMPTY_BALANCE);
      return;
    }

    const totalPackages = toNum(container.total_packages);
    const totalWeight = toNum(container.total_weight);

    // despatch_id can come back as a number from the API or a string from a
    // <select>/form — normalize both sides so exclusion actually matches.
    const excludeIdStr = excludeDespatchId != null ? String(excludeDespatchId) : null;

    const relevant = despatchList.filter(
      (d) =>
        String(d.container_id_fk) === containerIdStr &&
        (excludeIdStr == null || String(d.despatch_id) !== excludeIdStr)
    );

    const usedPackages = relevant.reduce((sum, d) => sum + toNum(d.no_of_packages), 0);
    const usedWeight = relevant.reduce((sum, d) => sum + toNum(d.weight), 0);

    // Clamp at 0 so a data inconsistency (e.g. total edited down after
    // despatches were recorded) never shows a misleading negative balance.
    setContainerBalances({
      totalPackages,
      totalWeight,
      usedPackages,
      usedWeight,
      balancePackages: Math.max(totalPackages - usedPackages, 0),
      balanceWeight: Math.max(totalWeight - usedWeight, 0),
    });
  }, [containerOptions, despatchList]);

  // Recompute the live balance whenever the despatch list refreshes (e.g.
  // after a save) so an open modal always reflects the latest remaining
  // capacity instead of a stale snapshot taken when it was opened.
  useEffect(() => {
    if (showModal && formData.container_id_fk) {
      computeBalance(formData.container_id_fk, formData.despatch_id || null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [despatchList]);

  // ------------------------------
  // Bills of Lading / Container Reference Table
  // Flat, one-row-per-container view built from the same job + container
  // lists already loaded for the form, with live balances so the user can
  // browse and jump straight into a despatch for a specific container.
  // ------------------------------
  const containerSummary = useMemo(() => {
    return containerOptions
      .filter((c) => c.value !== "")
      .map((c) => {
        const idStr = String(c.value);
        const relevant = despatchList.filter((d) => String(d.container_id_fk) === idStr);
        const usedPackages = relevant.reduce((sum, d) => sum + toNum(d.no_of_packages), 0);
        const usedWeight = relevant.reduce((sum, d) => sum + toNum(d.weight), 0);
        const totalPackages = toNum(c.total_packages);
        const totalWeight = toNum(c.total_weight);
        const job = jobOptions.find((j) => String(j.value) === String(c.job_id_fk));

        return {
          container_id: c.value,
          container_no: c.label,
          job_id_fk: c.job_id_fk,
          bl_number: job?.label || "—",
          despatch_count: relevant.length,
          totalPackages,
          totalWeight,
          // Weight already despatched against this container (sum of all
          // despatch rows), shown alongside total/balance so the three
          // numbers read together: Job Weight − Despatch Weight = Balance.
          despatchWeight: usedWeight,
          despatchPackages: usedPackages,
          balancePackages: Math.max(totalPackages - usedPackages, 0),
          balanceWeight: Math.max(totalWeight - usedWeight, 0),
        };
      });
  }, [containerOptions, jobOptions, despatchList]);

  // ------------------------------
  // BL No. Summary
  // Rolls containerSummary up to one row per BL No., summing packages and
  // weight (total / despatched / balance) across every container that sits
  // under that Bill of Lading — for a BL-level view instead of per-container.
  // ------------------------------
  const blSummary = useMemo(() => {
    const map = new Map();

    containerSummary.forEach((c) => {
      const key = String(c.job_id_fk ?? "");
      if (!map.has(key)) {
        map.set(key, {
          job_id_fk: c.job_id_fk,
          bl_number: c.bl_number,
          container_count: 0,
          despatch_count: 0,
          totalPackages: 0,
          totalWeight: 0,
          despatchPackages: 0,
          despatchWeight: 0,
        });
      }
      const entry = map.get(key);
      entry.container_count += 1;
      entry.despatch_count += c.despatch_count;
      entry.totalPackages += c.totalPackages;
      entry.totalWeight += c.totalWeight;
      entry.despatchPackages += c.despatchPackages;
      entry.despatchWeight += c.despatchWeight;
    });

    return Array.from(map.values()).map((entry) => ({
      ...entry,
      balancePackages: Math.max(entry.totalPackages - entry.despatchPackages, 0),
      balanceWeight: Math.max(entry.totalWeight - entry.despatchWeight, 0),
    }));
  }, [containerSummary]);

  const blColumns = useMemo(
    () => [
      { header: "S.No", label_condition: "s_no", enableColumnFilter: false, enableSorting: false },
      { header: "BL No.", accessorKey: "bl_number" },
      { header: "Containers", accessorKey: "container_count" },
      { header: "Total Packages", accessorKey: "totalPackages" },
      { header: "Despatched Packages", accessorKey: "despatchPackages" },
      { header: "Balance Packages", accessorKey: "balancePackages" },
      { header: "Total Weight (MT)", accessorKey: "totalWeight" },
      { header: "Despatched Weight (MT)", accessorKey: "despatchWeight" },
      { header: "Balance Weight (MT)", accessorKey: "balanceWeight" },
      { header: "Despatches", accessorKey: "despatch_count" },
    ],
    []
  );

  // Opens the despatch form pre-filled for a specific container picked from
  // the reference table above, with its live balance already computed.
  const handleReferenceView = useCallback((row) => {
    setFormData({
      ...initialFormState,
      job_id_fk: row.job_id_fk ?? "",
      container_id_fk: row.container_id,
    });
    computeBalance(row.container_id, null);
    setShowModal(true);
  }, [initialFormState, computeBalance]);

  const referenceColumns = useMemo(
    () => [
      { header: "S.No", label_condition: "s_no", enableColumnFilter: false, enableSorting: false },
      { header: "BL No.", accessorKey: "bl_number" },
      { header: "Container No", accessorKey: "container_no" },
      { header: "Total Packages", accessorKey: "totalPackages" },
      { header: "Balance Packages", accessorKey: "balancePackages" },
      { header: "Job Weight (MT)", accessorKey: "totalWeight" },
      { header: "Despatch Weight (MT)", accessorKey: "despatchWeight" },
      { header: "Balance Weight (MT)", accessorKey: "balanceWeight" },
      { header: "Despatches", accessorKey: "despatch_count" },
    ],
    []
  );

  // ------------------------------
  // Edit Handler
  // ------------------------------
  const handleEdit = useCallback((row) => {
    setFormData({ ...initialFormState, ...row });
    computeBalance(row.container_id_fk, row.despatch_id);
    setShowModal(true);
  }, [initialFormState, computeBalance]);

  // ------------------------------
  // Table Columns
  // ------------------------------
  const columns = useMemo(
    () => [
      { header: "S.No", label_condition: "s_no", enableColumnFilter: false, enableSorting: false },
      { header: "Job", accessorKey: "job_no" },
      { header: "Despatch Date", accessorKey: "despatch_date" },
      { header: "Container No", accessorKey: "container_no" },
      { header: "Lorry No.", accessorKey: "lorry_number" },
      { header: "Driver", accessorKey: "driver_name" },
      { header: "Phone", accessorKey: "driver_phone" },
      { header: "Despatch Wt (MT)", accessorKey: "weight" },
      {
        header: "Job Weight (MT)",
        cell: ({ row }) => {
          const match = containerSummary.find(
            (c) => String(c.container_id) === String(row.container_id_fk)
          );
          return match ? match.totalWeight : "—";
        },
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        header: "Balance Weight (MT)",
        cell: ({ row }) => {
          const match = containerSummary.find(
            (c) => String(c.container_id) === String(row.container_id_fk)
          );
          return match ? match.balanceWeight : "—";
        },
        enableSorting: false,
        enableColumnFilter: false,
      },
      { header: "e-Way Bill", accessorKey: "e_way_bill_no" },
      { header: "GC No.", accessorKey: "gc_no" },
      {
        header: "Actions",
        cell: ({ row }) => (
          <i
            className="ri-file-edit-fill text-primary cursor-pointer me-2"
            onClick={() => handleEdit(row)}
            title="Edit"
            style={{ fontSize: "18px" }}
          />
        ),
        enableSorting: false,
        enableColumnFilter: false,
      },
    ],
    [handleEdit, containerSummary]
  );

  // ------------------------------
  // Input Change Handler
  // ------------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    let updated = { ...formData, [name]: value };

    if (name === "job_id_fk") {
      // BL No. changed: reset the container + any qty already entered,
      // since the container list (and its balance) depends on the job.
      updated.container_id_fk = "";
      updated.no_of_packages = "";
      updated.weight = "";
      setContainerBalances(EMPTY_BALANCE);
    }

    if (name === "container_id_fk") {
      const selected = containerOptions.find((c) => c.value === value);
      // Container list is already scoped to the selected job, but keep
      // job_id_fk in sync in case a row is loaded via handleEdit first.
      updated.job_id_fk = selected?.job_id_fk || formData.job_id_fk || "";
      computeBalance(value, formData.despatch_id || null);
      // Reset any previously-entered qty so it's re-validated against the new container
      updated.no_of_packages = "";
      updated.weight = "";
    }

    if (name === "shed_name") {
      const selected = shedOptions.find((l) => l.value === value);
      if (selected) {
        updated.shed_contact_no = selected.contact_no || "";
      }
    }

    if (name === "no_of_packages" && containerBalances.balancePackages != null) {
      const val = toNum(value);
      // if (val > containerBalances.balancePackages) {
      //   updated.no_of_packages = containerBalances.balancePackages;
      //   showAlert(
      //     "warning",
      //     "Capped",
      //     `Only ${containerBalances.balancePackages} packages remaining — value capped.`,
      //     1800
      //   );
      // }
    }

    if (name === "weight" && containerBalances.balanceWeight != null) {
      const val = toNum(value);
      // if (val > containerBalances.balanceWeight) {
      //   updated.weight = containerBalances.balanceWeight;
      //   showAlert(
      //     "warning",
      //     "Capped",
      //     `Only ${containerBalances.balanceWeight} MT remaining — value capped.`,
      //     1800
      //   );
      // }
    }

    setFormData(updated);
  };

  // ------------------------------
  // Close Modal
  // ------------------------------
  const handleClose = () => {
    setShowModal(false);
    setFormData(initialFormState);
    setContainerBalances(EMPTY_BALANCE);
  };

  // ------------------------------
  // Submit Form
  // ------------------------------
  const handleSubmit = async () => {
    for (let field of formFields.filter((f) => f.required)) {
      if (!formData[field.name]) {
        showAlert("error", "Oops...", `${field.label} is required`);
        return;
      }
    }

    if (
      containerBalances.balancePackages != null &&
      toNum(formData.no_of_packages) > containerBalances.balancePackages
    ) {
      showAlert("error", "Oops...", `No. of Packages exceeds remaining balance of ${containerBalances.balancePackages}`);
      return;
    }

    if (
      containerBalances.balanceWeight != null &&
      toNum(formData.weight) > containerBalances.balanceWeight
    ) {
      showAlert("error", "Oops...", `Weight exceeds remaining balance of ${containerBalances.balanceWeight} MT`);
      return;
    }

    try {
      const response = await post("/operations/despatch", formData);
      if (response.status === 200) {
        showAlert("success", "Saved", response.message);
        // Refresh the despatch list so balances for this (and every other)
        // container reflect the newly saved quantities immediately.
        await fetchData();
        handleClose();
      } else {
        showAlert("error", response.status, response.message);
      }
    } catch (err) {
      showAlert("error", "Unexpected Error", err.message);
    }
  };

  // ------------------------------
  // Render
  // ------------------------------
  return (
    <>
      <div className="page-header d-flex justify-content-between align-items-center">
        <div>
          <div className="page-header-title">Despatch Orders</div>
          <div className="page-header-sub">Record a container despatch</div>
        </div>
        <button className="btn btn-primary btn-sm" onClick={() => setShowModal(true)}>
          Add Despatch
        </button>
      </div>

      <div className="card basic-data-table mt-3">
        <div className="card-header">
          <h5 className="card-title mb-0">BL No. Summary</h5>
          <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
            Packages & weight totals, despatched, and balance — rolled up per BL No. across all its containers.
          </p>
        </div>
        <div className="card-body">
          <Customtable
            table_title="BL Summary"
            columns={blColumns}
            data={blSummary}
            isGlobalFilter={true}
            isPagination={true}
            currentPage={blPage}
            setCurrentPage={setBlPage}
            isExportButton={true}
          />
        </div>
      </div>

      <div className="card basic-data-table mt-3">
        <div className="card-header">
          <h5 className="card-title mb-0">Bills of Lading / Containers</h5>
          <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
            Browse containers and click View to despatch one directly.
          </p>
        </div>
        <div className="card-body">
          <Customtable
            table_title="Bills of Lading"
            columns={referenceColumns}
            data={containerSummary}
            isGlobalFilter={true}
            isPagination={true}
            currentPage={referencePage}
            setCurrentPage={setReferencePage}
            isExportButton={false}
          />
        </div>
      </div>

      <div className="card basic-data-table mt-3">
        <div className="card-header">
          <h5 className="card-title mb-0">Despatch List</h5>
        </div>
        <div className="card-body">
          <Customtable
            table_title="Despatch List"
            columns={columns}
            data={despatchList}
            isGlobalFilter={true}
            isPagination={true}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            isExportButton={true}
          />
        </div>
      </div>

      <CommonModal
        show={showModal}
        title="Despatch Order"
        formFields={formFields}
        formData={formData}
        onChange={handleChange}
        onClose={handleClose}
        onSubmit={handleSubmit}
        submitText="Save"
      />
    </>
  );
};

export default Despatch;